import type { JourneyMode } from "@/data/schema/compiled";

interface TimelineJourneyToggleProps {
  journey: JourneyMode;
  onJourneyChange: (journey: JourneyMode) => void;
  onJourneyPrefetch: () => void;
}

export function TimelineJourneyToggle({
  journey,
  onJourneyChange,
  onJourneyPrefetch,
}: TimelineJourneyToggleProps) {
  return (
    <div className="timeline-options__journey" onMouseEnter={onJourneyPrefetch}>
      <button
        type="button"
        aria-pressed={journey === "book"}
        title="The order the book tells it"
        onClick={() => onJourneyChange("book")}
      >
        As Told
      </button>
      <button
        type="button"
        aria-pressed={journey === "universe"}
        title="The order events actually happened"
        onClick={() => onJourneyChange("universe")}
      >
        As It Happened
      </button>
    </div>
  );
}
